"use client";
import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const ImageCarousel = ({ onCityClick }) => {
  const settings = {
    dots: false,
    infinite: true,
    arrows: false,
    speed: 500,
    slidesToShow: 2.05,
    slidesToScroll: 1,
  };

  const slidesData = [
    {
      img: "https://firebasestorage.googleapis.com/v0/b/findmyvenueprod.firebasestorage.app/o/fmv%20cities%2FDubai-compressed_1_kxquzi.jpg?alt=media&token=6e311247-040c-400f-a8b8-abc9cbf85c2c",
      name: "Dubai",
      venus: "2829 Venues",
    },
    {
      img: "https://firebasestorage.googleapis.com/v0/b/findmyvenueprod.firebasestorage.app/o/fmv%20cities%2FAbu_Dhabi_slr7x6.jpg?alt=media&token=0535cf08-2dd0-4b51-b345-5d1f35f8e241",
      name: "Abu Dhabi",
      venus: "2829 Venues",
    },
    {
      img: "https://firebasestorage.googleapis.com/v0/b/findmyvenueprod.firebasestorage.app/o/fmv%20cities%2FRas_Al_Khaimah_hthpwd.jpg?alt=media&token=95336664-8510-4f1c-8c62-ada1de3de1cd",
      name: "Ras Al Khaimah",
      venus: "2829 Venues",
    },
    {
      img: "https://firebasestorage.googleapis.com/v0/b/findmyvenueprod.firebasestorage.app/o/fmv%20cities%2FSharjah-compressed_ngrlhi.jpg?alt=media&token=3a1d3870-4559-4ed8-b84d-8c7653f7fa0e",
      name: "Sharjah",
      venus: "2829 Venues",
    },
    {
      img: "https://firebasestorage.googleapis.com/v0/b/findmyvenueprod.firebasestorage.app/o/fmv%20cities%2FFujairah_cqybav.jpg?alt=media&token=5aa71f77-3349-42c0-9a7a-249b47293031",
      name: "Fujairah",
      venus: "2829 Venues",
    },
    {
      img: "https://firebasestorage.googleapis.com/v0/b/findmyvenueprod.firebasestorage.app/o/fmv%20cities%2FAjman_cp0adp.jpg?alt=media&token=0025da78-eec7-4579-931e-7195db74e528",
      name: "Ajman",
      venus: "2829 Venues",
    },
    {
      img: "https://firebasestorage.googleapis.com/v0/b/findmyvenueprod.firebasestorage.app/o/fmv%20cities%2FUmm_Al_Quwain_j3cfex.jpg?alt=media&token=ad889cbc-87b3-4cf6-9974-b50a4b84b213",
      name: "Umm Al Quwain",
      venus: "2829 Venues",
    },
  ];

  return (
    <div className="">
      <Slider {...settings}>
        {slidesData.map((e, i) => (
          <div
            key={i}
            className="px-2 w-full cursor-pointer"
            onClick={() => onCityClick(e.name)}
          >
            <div className="bg-white border rounded-lg  relative flex-col  w-full h-full flex items-center ">
              <img
              src={e.img}
              alt={e.name}
              loading={i === 0 ? "eager" : "lazy"}
              decoding="async"
              className="rounded-lg h-40 w-full"
            />

              <div className=" flex flex-col items-center justify-end pb-2 bg-shadow-gradient bottom-0 w-full h-[5rem] absolute rounded-b-lg  z-30">
                <h1 className=" text-lg font-medium">{e.name}</h1>
              </div>
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default ImageCarousel;
